(function(){

  const isSearchPage = /^\/search(?:\/|$)/.test(location.pathname);
  const isCollectionPage = /^\/collections(?:\/|$)/.test(location.pathname);
  if (!isSearchPage && !isCollectionPage) return;

  // Enables search-only square image and mobile ATC styles in the CSS asset.
  if (isSearchPage) document.documentElement.dataset.smSearchPage = 'true';

  if (window.__smNativeCardSwatches) return;
  window.__smNativeCardSwatches = true;

const results=document.querySelector('main')||document;

   const smvfRioCache=new Map();

   const smvfRioCardCache=new WeakMap();

   const cacheFinderRioMaps=doc=>{

      doc.querySelectorAll('script.rio-variant-map[data-product-handle]').forEach(script=>{

         const handle=script.dataset.productHandle;if(!handle)return;

         try{

            const data=JSON.parse(script.textContent);if(!Array.isArray(data.mapping))return;

            const byVariant=new Map(),allMedia=new Set();

            data.mapping.forEach(entry=>{byVariant.set(String(entry.id),entry);(entry.media||[]).forEach(id=>allMedia.add(String(id)))});

            smvfRioCache.set(handle,{byVariant,allMedia});

         }catch(error){console.warn('SlickMod Vehicle Finder: invalid RIO map for',handle,error)}

      });

   };

   const switchFinderRioSlides=(card,variantId)=>{

      const handle=smvfProductHandle(card);

      const data=smvfRioCache.get(handle);

      const entry=data?.byVariant.get(String(variantId));

      if(!entry||!Array.isArray(entry.media)||!entry.media.length)return false;

      let gallery=smvfRioCardCache.get(card);

      if(!gallery){gallery={slides:[...card.querySelectorAll('slideshow-slide[slide-id]')],slideshow:card.querySelector('slideshow-component'),scroller:card.querySelector('[ref="scroller"]'),sequence:0};smvfRioCardCache.set(card,gallery)}

      if(!gallery.slides.length)return false;

      const selectedMedia=new Set(entry.media.map(String));

      if(!gallery.slides.some(slide=>selectedMedia.has(String(slide.getAttribute('slide-id')))))return false;

      const sequence=++gallery.sequence;

      requestAnimationFrame(()=>{

         if(!card.isConnected||!results.contains(card)||sequence!==gallery.sequence)return;

         const desktop=window.innerWidth>=1025;

         let desktopCount=0,firstSelected=null,firstVisible=null;

         const changes=gallery.slides.map(slide=>{

            const id=String(slide.getAttribute('slide-id'));

            const selected=selectedMedia.has(id),variantMedia=data.allMedia.has(id);

            const show=desktop?selected&&desktopCount<2:(!variantMedia||selected);

            if(show){if(desktop)desktopCount++;if(!firstVisible)firstVisible=slide;if(selected&&!firstSelected)firstSelected=slide}

            return {slide,show};

         });

         changes.forEach(({slide,show})=>{

            if(slide.hidden===show)slide.hidden=!show;

            const aria=show?'false':'true';if(slide.getAttribute('aria-hidden')!==aria)slide.setAttribute('aria-hidden',aria);

         });

         card.dataset.currentVariant=String(variantId);

         const target=firstSelected||firstVisible;

         if(gallery.scroller&&target){const left=target.offsetLeft;if(Math.abs(gallery.scroller.scrollLeft-left)>1)gallery.scroller.scrollTo({left,top:0,behavior:'instant'})}

         if(gallery.slideshow&&typeof gallery.slideshow.current==='number'&&gallery.slideshow.current!==0){try{gallery.slideshow.current=0}catch(error){}}

      });

      return true;

   };

   let finderRioDesktop=window.innerWidth>=1025;

   window.addEventListener('resize',()=>{

      const desktop=window.innerWidth>=1025;if(desktop===finderRioDesktop)return;finderRioDesktop=desktop;

      results.querySelectorAll('product-card[data-smvf-variant-id]').forEach(card=>switchFinderRioSlides(card,card.dataset.smvfVariantId));

   },{passive:true});

   const smvfColorNames={black:'#111111',white:'#ffffff',red:'#d71920',blue:'#1769aa',green:'#287447',yellow:'#f2d02f',orange:'#f07824',purple:'#7540a0',pink:'#e88cae',gray:'#888888',grey:'#888888',silver:'#c5c7c9',gold:'#c6a34b',brown:'#795548',clear:'linear-gradient(135deg,#eee 25%,#bbb 25%,#bbb 50%,#eee 50%,#eee 75%,#bbb 75%)'};

   const smvfSwatchImageBase='https://cdn.shopify.com/s/files/1/0049/5674/9927/files/';

   const smvfSwatchImages={

      'chrome':'chrome.jpg?v=1791794889',

      'dark smoke':'ds-small-swatch.jpg?v=1775775767',

      'light smoke':'ls-small-swatch.jpg?v=1775775765',

      'red':'red-small-swatch.jpg?v=1775775771',

      'yellow':'yel-small-swatch.jpg?v=1775775772',

      'red w/35% light':'red-ls-tint-swatch.jpg?v=1775775766',

      'red w/20% dark':'red-ds-tint-swatch.jpg?v=1775775766',

      'gloss white':'gloss-white-swatch.jpg?v=1775775766',

      'gloss red':'gloss-red-swatch.jpg?v=1776232855',

      'gloss blue':'gloss-blue-swatch.jpg?v=1775775766',

      'carbon fiber':'carbon-fiber-swatch.jpg?v=1776231239',

      'satin black':'satin-black-swatch.jpg?v=1775775766',

      'gloss black':'gloss-black-swatch.jpg?v=1776178881',

      'matte black':'matte-black-swatch.jpg?v=1776434681'

   };

   const smvfSwatchImageFor=value=>{

      const key=String(value||'').trim().toLowerCase().replace(/\s+/g,' ').replace(/\s*\/\s*/g,'/');

      return smvfSwatchImages[key]?smvfSwatchImageBase+smvfSwatchImages[key]:'';

   };

   const smvfColorFor=value=>{const text=String(value||'').toLowerCase();for(const [name,color] of Object.entries(smvfColorNames)){if(text.includes(name))return color}return '#dedede'};

   const smvfProductHandle=card=>{const link=card.querySelector('a[href*="/products/"]');if(!link)return '';try{return new URL(link.href,location.origin).pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0]||''}catch(e){return ''}};

   const smvfImageUrl=value=>{if(!value)return '';if(typeof value==='string')return value;if(value.src)return value.src;return ''};

   const smvfColorOption=product=>{const options=product.options||[];let index=options.findIndex(o=>/^(color|colour|finish|style)$/i.test(typeof o==='string'?o:o.name||''));if(index<0)index=options.findIndex(o=>/color|colour/i.test(typeof o==='string'?o:o.name||''));return index};

   const smvfVariantOption=(variant,index)=>variant['option'+(index+1)];

const legacySelectors='.swatches-globo--list,.ul-swatches-list,.globo-swatch-product-detail,.slickmod-native-search-swatch-wrap';

function cleanLegacy(card){

   card.querySelectorAll(legacySelectors).forEach(node=>node.remove());

   card.classList.remove('globo-swatch-product-item');

   card.removeAttribute('data-globoswatch-loaded');

}

function applyVariant(card,product,variant){

   card.dataset.smvfVariantId=String(variant.id);

   card.dataset.currentVariant=String(variant.id);

   card.querySelectorAll('input[name="id"]').forEach(input=>input.value=variant.id);

   card.querySelectorAll('a[href*="/products/"]').forEach(link=>{

      const url=new URL(link.href,location.origin);url.searchParams.set('variant',variant.id);link.href=url.toString();

   });

   card.querySelectorAll('[data-href*="/products/"]').forEach(node=>{

      try{const url=new URL(node.dataset.href,location.origin);url.searchParams.set('variant',variant.id);node.dataset.href=url.toString()}catch(_){}

   });

   const price=card.querySelector('product-price');

   if(price){

      const amount=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(variant.price/100);

      const priceNodes=price.querySelectorAll('.price:not(.price--compare)');

      priceNodes.forEach(node=>{if(!node.closest('.price__compare,.price__sale'))node.textContent=amount;});

   }

   if(!switchFinderRioSlides(card,variant.id)){

      const image=card.querySelector('[ref="cardGallery"] img,.card-gallery img');

      const url=smvfImageUrl(variant.featured_image);

      if(image&&url){image.src=url;image.removeAttribute('srcset');image.removeAttribute('sizes');}

   }

}

function addCardAtc(card,mount,getVariant,productId){

   const button=document.createElement('button');button.type='button';button.className='slickmod-native-search-atc';button.textContent='Add to Cart';

   button.addEventListener('click',async event=>{

      event.preventDefault();event.stopPropagation();

      const variant=getVariant();if(!variant?.available||button.dataset.busy)return;

      button.dataset.busy='true';button.disabled=true;button.textContent='Adding…';

      const routes=window.Shopify?.routes?.root||'/';

      try{

         const {CartAddEvent}=await import('@theme/events');

         const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node=>node.dataset.sectionId).filter(Boolean))].slice(0,5);

         const response=await fetch(routes+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(variant.id),quantity:1}],sections:sectionIds,sections_url:location.pathname})});

         const added=await response.json();if(!response.ok)throw new Error(added.description||'Could not add item');

         const cartResponse=await fetch(routes+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!cartResponse.ok)throw new Error('Cart refresh failed');const cart=await cartResponse.json();

         document.dispatchEvent(new CartAddEvent(cart,String(variant.id),{didError:false,source:'product-form-component',itemCount:1,productId:String(productId),variantId:String(variant.id),sections:added.sections}));

         button.textContent='✓ Added';

      }catch(error){button.textContent='Couldn’t Add';console.warn('SlickMod card Add to Cart:',error);}

      finally{setTimeout(()=>{delete button.dataset.busy;const current=getVariant();button.disabled=!current?.available;button.textContent=current?.available?'Add to Cart':'Sold out';},1200);}

   });

   mount.appendChild(button);return button;

}

async function initCard(card){

   if(card.closest('[id^="SlickModVehicleFinder-"]'))return;

   const mount=card.querySelector('.sm-native-card-options');

   if(!mount||mount.dataset.ready)return;

   mount.dataset.ready='loading';

   let product;

   try{

      const data=mount.querySelector('script.sm-native-variant-data');

      if(data)product=JSON.parse(data.textContent);

      else product=await getCardProduct(smvfProductHandle(card));

   }catch(error){delete mount.dataset.ready;console.warn('SlickMod swatches: product data unavailable',error);return;}

   if(!card.isConnected)return;

   const colorIndex=smvfColorOption(product);

   if(colorIndex<0){const variant=product.variants.find(v=>String(v.id)===mount.dataset.initialVariant)||product.variants.find(v=>v.available)||product.variants[0];if(!variant)return;cleanLegacy(card);card.classList.add('sm-native-swatches-ready');mount.classList.add('smvf__custom-options');mount.replaceChildren();const atc=addCardAtc(card,mount,()=>variant,product.id);atc.disabled=!variant.available;atc.textContent=variant.available?'Add to Cart':'Sold out';applyVariant(card,product,variant);mount.dataset.ready='true';return;}

   const variants=product.variants||[];

   let selected=variants.find(v=>String(v.id)===mount.dataset.initialVariant)||variants.find(v=>v.available)||variants[0];

   if(!selected)return;

   cacheFinderRioMaps(card);

   cleanLegacy(card);

   card.classList.add('sm-native-swatches-ready');

   mount.classList.add('smvf__custom-options');

   const label=document.createElement('span');label.className='smvf__custom-options-label';

   const row=document.createElement('div');row.className='smvf__swatch-row';row.setAttribute('role','group');row.setAttribute('aria-label','Color choices');

   const values=[...new Set(variants.map(v=>smvfVariantOption(v,colorIndex)).filter(Boolean))];

   if(values.length>=4)row.classList.add('smvf__swatch-row--compact');

   if(values.length>=5)row.classList.add('smvf__swatch-row--five-plus');

   const choices=[];

   let atc=null;

   function chooseVariant(value){

      const otherOptions=product.options.map((_,index)=>index).filter(index=>index!==colorIndex);

      return variants.find(v=>smvfVariantOption(v,colorIndex)===value&&v.available&&otherOptions.every(index=>smvfVariantOption(v,index)===smvfVariantOption(selected,index)))||variants.find(v=>smvfVariantOption(v,colorIndex)===value&&v.available)||variants.find(v=>smvfVariantOption(v,colorIndex)===value);

   }

   function refresh(updateMedia=true){

      label.textContent='Color: '+smvfVariantOption(selected,colorIndex);

      choices.forEach(({button,input,value})=>{

         const active=value===smvfVariantOption(selected,colorIndex);

         button.setAttribute('aria-pressed',String(active));input.checked=active;input.dataset.variantId=String(selected.id);

      });

      if(atc&&!atc.dataset.busy){atc.disabled=!selected.available;atc.textContent=selected.available?'Add to Cart':'Sold out';}

      if(updateMedia)applyVariant(card,product,selected);

   }

   values.forEach(value=>{

      const variant=chooseVariant(value);

      const button=document.createElement('button');button.type='button';button.className='smvf__color-swatch';button.title=value;button.setAttribute('aria-label','Choose '+value);button.disabled=!variants.some(v=>smvfVariantOption(v,colorIndex)===value&&v.available);

      const image=smvfSwatchImageFor(value)||smvfImageUrl(variant?.featured_image);

      if(image)button.style.backgroundImage='url("'+image.replace(/"/g,'%22')+'")';else button.style.background=smvfColorFor(value);

      const input=document.createElement('input');input.type='radio';input.hidden=true;input.name='sm-native-color-'+product.id+'-'+Math.random().toString(36).slice(2);input.dataset.variantId=String(selected.id);

      button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();if(Date.now() < suppressUntil)return;const next=chooseVariant(value);if(!next?.available)return;selected=next;refresh();});

      choices.push({button,input,value});row.append(button,input);

   });

   let drag=null,suppressUntil=0;

   row.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||row.scrollWidth<=row.clientWidth)return;drag={id:event.pointerId,x:event.clientX,left:row.scrollLeft,moved:false};});

   row.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId)return;const delta=event.clientX-drag.x;if(!drag.moved&&Math.abs(delta)>5){drag.moved=true;row.setPointerCapture(event.pointerId);row.classList.add('is-dragging');}if(drag.moved){event.preventDefault();row.scrollLeft=drag.left-delta;}});

   const finish=event=>{if(!drag||drag.id!==event.pointerId)return;if(drag.moved)suppressUntil=Date.now()+350;if(row.hasPointerCapture(event.pointerId))row.releasePointerCapture(event.pointerId);drag=null;row.classList.remove('is-dragging');};

   row.addEventListener('pointerup',finish);row.addEventListener('pointercancel',finish);

   mount.replaceChildren(label,row);atc=addCardAtc(card,mount,()=>selected,product.id);mount.dataset.ready='true';refresh(false);

}

const productRequests=new Map();

async function getCardProduct(handle){

   if(!handle)throw new Error('Product handle missing');

   if(!productRequests.has(handle)){

      const request=fetch((window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(response=>{if(!response.ok)throw new Error('Product data request failed');return response.json();}).catch(error=>{productRequests.delete(handle);throw error;});

      productRequests.set(handle,request);

   }

   return productRequests.get(handle);

}

const seenCards=new WeakSet();

const nearbyObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){nearbyObserver.unobserve(entry.target);initCard(entry.target);}});},{rootMargin:'350px 0px'}):null;

function registerCard(card){

   if(seenCards.has(card)||card.closest('[id^="SlickModVehicleFinder-"]'))return;

   let mount=card.querySelector('.sm-native-card-options');

   if(!mount){

      if(!card.closest('results-list,.product-grid')||!smvfProductHandle(card))return;

      const content=card.querySelector('.product-card__content');if(!content)return;

      mount=document.createElement('div');mount.className='sm-native-card-options';content.appendChild(mount);

   }

   seenCards.add(card);cleanLegacy(card);

   if(nearbyObserver)nearbyObserver.observe(card);else initCard(card);

}

const pendingCards=new Set();let queued=false;

function queueCard(card){if(!card)return;pendingCards.add(card);if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;pendingCards.forEach(registerCard);pendingCards.clear();});}

new MutationObserver(records => {
  const cardsNeedingRebuild = new Set();

  records.forEach(record => {
    // Detect swatch containers removed during a section refresh.
    record.removedNodes.forEach(node => {
      if (node.nodeType !== 1) return;

      const containsSwatchUI =
        node.matches?.(
          '.sm-native-card-options, .smvf__custom-options, .smvf__swatch-row'
        ) ||
        node.querySelector?.(
          '.sm-native-card-options, .smvf__custom-options, .smvf__swatch-row'
        );

      if (!containsSwatchUI) return;

      // The entire product card may have been removed.
      if (node.matches('product-card')) {
        cardsNeedingRebuild.add(node);
      }

      // Or Horizon may have replaced only part of an existing card.
      const parentCard =
        record.target instanceof Element
          ? record.target.closest('product-card')
          : null;

      if (parentCard) {
        cardsNeedingRebuild.add(parentCard);
      }
    });

    // Preserve the existing added-node handling.
    record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;

      if (node.matches(legacySelectors)) {
        const card = node.closest('product-card');

        if (
          card?.querySelector('.sm-native-card-options') &&
          !card.closest('[id^="SlickModVehicleFinder-"]')
        ) {
          node.remove();
        }

        return;
      }

      if (node.matches('product-card')) {
        queueCard(node);
      }

      node.querySelectorAll('product-card').forEach(queueCard);

      if (node.matches('.sm-native-card-options')) {
        queueCard(node.closest('product-card'));
      }
    });
  });

  // Allow previously initialized cards to rebuild missing swatches.
  cardsNeedingRebuild.forEach(card => {
    seenCards.delete(card);

    const mount = card.querySelector('.sm-native-card-options');

    if (mount && mount.dataset.ready !== 'loading') {
      delete mount.dataset.ready;
    }

    // Detached cards will be picked up when Horizon adds them again.
    if (card.isConnected) {
      queueCard(card);
    }
  });
}).observe(results, {
  childList: true,
  subtree: true
});

results.querySelectorAll('product-card').forEach(registerCard);

})();
